/* eslint-disable no-shadow */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { detect } from "detect-browser";
import { connect } from "react-redux";
import {
  closeReviewPage,
  submitReview,
} from "../../../actions/employerPendingReviewsActions";
import RatingSteps from "./RatingSteps";
import Submitting from "../../shared/loaders/Submitting";
import ModalThankYou from "../../shared/loaders/ModalThankYou";
import {
  Wrapper,
  Card,
  Title,
  TitleText,
  Form,
  Label,
  BackLink,
} from "./styles/review-styles";

export class LeaveReview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reviewStep: 1,
      reviewMessage: "",
      step1Rating: null,
      step2Rating: null,
      step3Rating: null,
      step4Rating: null,
    };
  }

  componentDidMount() {
    document.body.classList.add("leave-a-review");
  }

  setReviewMessage = (e) => {
    this.setState({
      reviewMessage: e.target.value,
    });
  };

  setRating = (e) => {
    const { reviewStep } = this.state;

    this.setState({
      [e.target.name]: parseInt(e.target.value, 10),
    });

    setTimeout(() => {
      this.setState({
        reviewStep: reviewStep + 1,
      });
    }, 1300);
  };

  render() {
    const {
      pendingReview,
      submitReview,
      formLoading,
      formThankYou,
      closeReviewPage,
    } = this.props;

    const { agentName, agentCompany, jobTitle, jobId, reviewId } =
      pendingReview;

    const {
      reviewMessage,
      reviewStep,
      step1Rating,
      step2Rating,
      step3Rating,
      step4Rating,
    } = this.state;

    const iOS = detect().name === "ios";

    const submitData = {
      reviewMessage,
      step1Rating,
      step2Rating,
      step3Rating,
      step4Rating,
      reviewId,
      jobId,
    };

    // it's possible that the recruiter user
    // has been deleted
    const recruiterUserExists = agentName !== null;

    return (
      <Fragment>
        <BackLink onClick={() => closeReviewPage()}>
          <NavLink to="/?from=review/" id="router-link">
            Jobs
          </NavLink>
        </BackLink>
        <Wrapper>
          <Card
            iOS={iOS}
            data-test-id="job-profile-edit-form"
            className="animated fadeInDown"
          >
            {formLoading && <Submitting />}
            {formThankYou && <ModalThankYou text="Thank you for your review" />}
            <Title>
              <TitleText>{jobTitle}</TitleText>
            </Title>
            <Form
              onSubmit={(e) => submitReview(e, submitData)}
              iOS={iOS}
              onKeyPress={this.onKeyPress}
            >
              <Label>
                Please leave a review for{" "}
                {recruiterUserExists && (
                  <>
                    <span>{agentName}</span> at{" "}
                  </>
                )}
                <span>{agentCompany}</span> who helped you fill this role:
              </Label>
              <RatingSteps
                setRating={this.setRating}
                reviewStep={reviewStep}
                step1Rating={step1Rating}
                step2Rating={step2Rating}
                step3Rating={step3Rating}
                step4Rating={step4Rating}
                reviewMessage={reviewMessage}
                setReviewMessage={this.setReviewMessage}
              />
            </Form>
          </Card>
        </Wrapper>
      </Fragment>
    );
  }
}

LeaveReview.propTypes = {
  pendingReview: PropTypes.shape({
    reviewId: PropTypes.number,
    jobId: PropTypes.number,
    jobTitle: PropTypes.string,
    agentName: PropTypes.string,
    agentCompany: PropTypes.string,
  }).isRequired,
  submitReview: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
  formThankYou: PropTypes.bool.isRequired,
  closeReviewPage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pendingReview: state.employerPendingReviews.pendingReview,
  formLoading: state.employerPendingReviews.formLoading,
  formThankYou: state.employerPendingReviews.formThankYou,
});

export default connect(mapStateToProps, { submitReview, closeReviewPage })(
  LeaveReview
);
